import { EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../../services/user.service';
import { ActionSource, Page, UserActionType } from '../../../services/event-tracker/event-tracker.service';
import { Report } from '../../../../models/measure/report';
import { ObjectUtils } from '../../../utils/object.utils';
import { CommonConstant } from '../../../app.constants';
var MeasureModuleDropdownComponent = /** @class */ (function () {
    function MeasureModuleDropdownComponent(translate, userService) {
        this.translate = translate;
        this.userService = userService;
        this.afterActivateModule = new EventEmitter();
        this.invalidModification = new EventEmitter();
        this.availableModuleList = [];
        this.selectedModuleIds = [];
        this.selectedGroupId = CommonConstant.ALL_MODULES_ID;
        this.moduleGroups = [
            {
                id: 1,
                name: this.translate.instant('module_groups.selected'),
                modules: []
            },
            {
                id: 2,
                name: this.translate.instant('module_groups.all'),
                modules: []
            },
            {
                id: 3,
                name: this.translate.instant('module_groups.performance'),
                modules: ['Performance Timeline', 'Performance KPIs', 'Market Drill-down', 'Mention Timeline', 'Best Performing Influencers', 'Interactions Report', 'Post Benchmark']
            },
            {
                id: 4,
                name: this.translate.instant('module_groups.exposure'),
                modules: ['Mention Timeline', 'Exposure KPIs', 'Platform Drill-down', 'Best Performance Exposures', 'Interactions Report', 'Post Benchmark']
            },
            {
                id: 5,
                name: this.translate.instant('module_groups.segmentation'),
                modules: ['Exposure KPIs', 'Influencers Overview', 'Topics Drill-down', 'Industries Drill-down']
            },
            {
                id: 6,
                name: this.translate.instant('module_groups.insight'),
                modules: ['Channel Opportunities', 'Average Benchmark Performance', 'Return on Investment (ROI)']
            }
        ];
    }
    MeasureModuleDropdownComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes.isEditable && changes.isEditable.previousValue && changes.isEditable.currentValue
            && !ObjectUtils.isEquals(changes.isEditable.currentValue, changes.isEditable.previousValue)) {
            if (changes.isEditable.currentValue) {
                this.initializeModuleList(this.selectedReport);
            }
            else {
                this.availableModuleList = this.availableModuleList.filter(function (m) { return m.isActive; });
            }
        }
        if (changes.selectedReport && changes.selectedReport.currentValue && changes.selectedReport.previousValue
            && !ObjectUtils.isEquals(changes.selectedReport.currentValue, changes.selectedReport.previousValue)) {
            var selectedGroup = this.moduleGroups.find(function (mg) { return mg.id === _this.selectedGroupId; });
            var moduleIds = changes.selectedReport.currentValue.sectionList.map(function (s) { return s.id; });
            if (this.isEditable) {
                this.updateModuleList(moduleIds, selectedGroup);
            }
            else {
                this.selectedModuleIds = moduleIds;
                this.availableModuleList = moduleIds.map(function (sm, index) {
                    var module = _this.moduleList.find(function (m) { return m.id === sm; });
                    return Object.assign({}, module, {
                        isActive: true,
                        position: index
                    });
                });
            }
        }
    };
    MeasureModuleDropdownComponent.prototype.ngOnInit = function () {
        this.initializeModuleList(this.selectedReport);
    };
    MeasureModuleDropdownComponent.prototype.initializeModuleList = function (selectedReport) {
        var _this = this;
        this.selectedModuleIds = selectedReport.sectionList.map(function (s) { return s.id; });
        this.availableModuleList = this.selectedModuleIds.map(function (sm, index) {
            var module = _this.moduleList.find(function (m) { return m.id === sm; });
            return Object.assign({}, module, {
                isActive: true,
                position: index
            });
        });
    };
    Object.defineProperty(MeasureModuleDropdownComponent.prototype, "isFreeUser", {
        get: function () {
            return this.userService.isFreeUser();
        },
        enumerable: true,
        configurable: true
    });
    MeasureModuleDropdownComponent.prototype.onSelectGroup = function (evt) {
        if (evt) {
            var selectedGroup = this.moduleGroups.find(function (mg) { return mg.id === evt.id; });
            this.updateModuleList(this.selectedModuleIds, selectedGroup);
        }
    };
    MeasureModuleDropdownComponent.prototype.measureContextData = function () {
        var data = {
            action: UserActionType.ACTION,
            item: Page.REPORT,
            params: {
                action: this.selectedReport ? UserActionType.UPDATE : UserActionType.CREATE,
                source: ActionSource.PAGE
            },
        };
        if (this.selectedReport) {
            data = Object.assign({}, data, {
                report: {
                    id: this.selectedReport.id,
                    name: this.selectedReport.name
                }
            });
        }
        return data;
    };
    MeasureModuleDropdownComponent.prototype.onActivateModule = function (moduleId) {
        var _this = this;
        var selectedIndex = this.selectedModuleIds.indexOf(moduleId);
        var module = this.availableModuleList.find(function (m) { return m.id === moduleId; });
        if (!module) {
            return;
        }
        if (selectedIndex >= 0) {
            this.selectedModuleIds.splice(selectedIndex, 1);
            module.isActive = false;
        }
        else {
            module.isActive = true;
            var insertIndex = this.findActiveModulePosition(moduleId);
            this.selectedModuleIds.splice(insertIndex, 0, moduleId);
        }
        var newSelectedModuleList = this.selectedModuleIds.map(function (sm) { return _this.moduleList.find(function (m) { return m.id === sm; }); });
        this.afterActivateModule.emit(newSelectedModuleList);
    };
    MeasureModuleDropdownComponent.prototype.findActiveModulePosition = function (module) {
        var activePos = this.availableModuleList.findIndex(function (am) { return am.id === module; });
        var firstActiveModuleAfter = this.availableModuleList.find(function (m, index) { return m.isActive && index > activePos; });
        if (!firstActiveModuleAfter) {
            var firstActiveModuleBefore = this.availableModuleList.find(function (m, index) { return m.isActive && index < activePos; });
            return !firstActiveModuleBefore ? null : this.selectedModuleIds.indexOf(firstActiveModuleBefore.id) + 1;
        }
        else {
            return this.selectedModuleIds.indexOf(firstActiveModuleAfter.id);
        }
    };
    MeasureModuleDropdownComponent.prototype.updateModuleList = function (selectedModuleIds, selectedGroup) {
        var _this = this;
        if (selectedGroup.id === 1) {
            this.availableModuleList = selectedModuleIds.map(function (sm) { return _this.moduleList.find(function (m) { return m.id === sm; }); });
        }
        else if (selectedGroup.id === CommonConstant.ALL_MODULES_ID) {
            this.availableModuleList = this.moduleList.map(function (sm) { return sm; });
        }
        else {
            this.availableModuleList = this.moduleList.filter(function (m) { return selectedGroup.modules.indexOf(m.name) >= 0; });
        }
        this.updateSelectedModule();
    };
    MeasureModuleDropdownComponent.prototype.updateSelectedModule = function () {
        var _this = this;
        this.availableModuleList.forEach(function (sm) {
            if (_this.selectedModuleIds.indexOf(sm.id) >= 0) {
                sm.isActive = true;
            }
            else {
                sm.isActive = false;
            }
        });
    };
    MeasureModuleDropdownComponent.prototype.afterDropModule = function (dropEvent) {
        var _this = this;
        // not allow to update default report
        if (this.selectedReport.is_default_report) {
            this.invalidModification.emit(true);
            return;
        }
        // swap selected module index
        var droppedModule = this.availableModuleList[dropEvent.draggedModuleIndex];
        this.availableModuleList[dropEvent.draggedModuleIndex] = this.availableModuleList[dropEvent.droppedModuleIndex];
        this.availableModuleList[dropEvent.droppedModuleIndex] = droppedModule;
        var activeModules = this.availableModuleList.filter(function (m) { return m.isActive; });
        var activeModulesIds = activeModules.map(function (am) { return am.id; });
        var nextSelectedModulesId = this.selectedModuleIds.map(function (sm) {
            if (activeModulesIds.indexOf(sm) >= 0) {
                return -1;
            }
            else {
                return sm;
            }
        });
        activeModulesIds.forEach(function (m) {
            var mIndex = nextSelectedModulesId.indexOf(-1);
            nextSelectedModulesId.splice(mIndex, 1, m);
        });
        this.selectedModuleIds = nextSelectedModulesId;
        console.log(this.selectedModuleIds);
        var nextSelectedModuleList = nextSelectedModulesId.map(function (ms) { return _this.moduleList.find(function (m) { return m.id === ms; }); });
        this.afterActivateModule.emit(nextSelectedModuleList);
    };
    Object.defineProperty(MeasureModuleDropdownComponent.prototype, "selectedModuleName", {
        get: function () {
            var _this = this;
            var selectedModule = this.moduleGroups.find(function (mg) { return mg.id === _this.selectedGroupId; });
            if (!selectedModule) {
                return '';
            }
            var moduleIndex = selectedModule.name.indexOf('Module');
            return selectedModule.name.substring(0, moduleIndex);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureModuleDropdownComponent.prototype, "shortModule", {
        get: function () {
            return this.selectedGroupId === CommonConstant.ALL_MODULES_ID;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureModuleDropdownComponent.prototype, "middleShortModule", {
        get: function () {
            return this.selectedGroupId === 6;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureModuleDropdownComponent.prototype, "mediumModule", {
        get: function () {
            return this.selectedGroupId === 1 || this.selectedGroupId === 4;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureModuleDropdownComponent.prototype, "shouldDisableFreemiumFeature", {
        get: function () {
            return this.isFreeUser && !this.userService.isAdmin;
        },
        enumerable: true,
        configurable: true
    });
    MeasureModuleDropdownComponent.prototype.initializeSelectedModuleForNewReport = function () {
        this.selectedModuleIds = [];
    };
    MeasureModuleDropdownComponent.prototype.closeTooltip = function (t) {
        if (t) {
            t.close();
        }
    };
    return MeasureModuleDropdownComponent;
}());
export { MeasureModuleDropdownComponent };



// WEBPACK FOOTER //
// ./src/app/main/measure/measure-module-dropdown/measure-module-dropdown.component.ts.pre-build-optimizer.js